// Shared constants for the live training experience.

/**
 * The hand-off cue the rep says to move the AI customer from the rep-led
 * phase into surfacing knowledge-base questions. Kept here (single source of
 * truth) so the instructions modal, in-session hint, and any future copy all
 * show the exact same phrase. The backend detects variations of this — the
 * rep does not have to say it verbatim.
 */
export const TRAINING_TRIGGER_PHRASE = 'Do you have any questions for me?';
